export const areas: Record<string, string> = {
  '1': 'The Riverbank (A1)',
  '2': 'Clearfell (A1)',
  '3': 'Mud Burrow (A1)',
  '4': 'The Grelwood (A1)',
  '5': 'The Red Vale (A1)',
  '6': 'The Grim Tangle (A1)',
  '7': 'Cemetery of the Eternals (A1)',
  '8': 'Mausoleum of the Praetor (A1)',
  '9': 'Tomb of the Consort (A1)',
  '10': "Hunting Grounds (A1)",
  '11': "Freythorn (A1)",
  '12': "Ogham Farmlands (A1)",
  '13': "Ogham Village (A1)",
  '14': "The Manor Ramparts (A1)",
  '15': "Ogham Manor (A1)",
  '16': "Vastiri Outskirts (A2)",
  '17': "Mawdun Quarry (A2)",
  '18': "Mawdun Mine (A2)",
  '19': "Traitor\'s Passage (A2)",
  '20': "The Halani Gates (A2)",
  '21': "Keth (A2)",
  '22': "The Lost City (A2)",
  '23': "Mastodon Badlands (A2)",
  '24': "The Bone Pits (A2)",
  '25': "Valley of the Titans (A2)",
  '26': "The Titan Grotto (A2)",
  '27': "The Titan Grotto (A2)",
  '28': "Deshar (A2)",
  '29': "Path of Mourning (A2)",
  '30': "The Spires of Deshar (A2)",
  '31': "The Dreadnought (A2)",
  '32': "Dreadnought Vanguard (A2)",
  '33': "Sandswept Marsh (A3)",
  '34': "Jungle Ruins (A3)",
  '35': "Infested Barrens (A3)",
  '36': "Chimeral Wetlands (A3)",
  '37': "Jiquani\'s Machinarium (A3)",
  '38': "Jiquani\'s Sanctum (A3)",
  '39': "The Matlan Waterways (A3)",
  '40': "The Drowned City (A3)",
  '41': "The Molten Vault (A3)",
  '42': "Temple of Kopec (A3)",
  '43': "Utzaal (A3)",
  '44': "Aggorat (A3)",
  '45': "The Black Chambers (A3)",
  '46': "Isle of Kin (A4)",
  '47': "Volcanic Warrens (A4)",
  '48': "Journey's End (A4)",
  '49': "Eye of Hinekora (A4)",
  '50': "Halls of the Dead (A4)",
  '51': "Trial of the Ancestors (A4)",
  '52': "Arastas (A4)",
  '53': "Ngakanu (A4)",
  '54': "Epilogue",
  '55': "Epilogue",
  '56': "Epilogue",
  '57': "Epilogue",
  '58': "Epilogue",
  '59': "Epilogue",
  '60': "Epilogue",
  '61': "Epilogue",
  '62': "Epilogue",
  '63': "Epilogue",
  '64': "Epilogue",
  '65': "Waystone (Tier 1)",
  '66': "Waystone (Tier 2)",
  '67': "Waystone (Tier 3)",
  '68': "Waystone (Tier 4)",
  '69': "Waystone (Tier 5)",
  '70': "Waystone (Tier 6)",
  '71': "Waystone (Tier 7)",
  '72': "Waystone (Tier 8)",
  '73': "Waystone (Tier 9)",
  '74': "Waystone (Tier 10)",
  '75': "Waystone (Tier 11)",
  '76': "Waystone (Tier 12)",
  '77': "Waystone (Tier 13)",
  '78': "Waystone (Tier 14)",
  '79': "Waystone (Tier 15)",
  '80': "Waystone (Tier 16)",
};
